import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';

export * from './consts/deposit.policy';
export * from './consts/driver-eligibility.policy';
export * from './consts/late-return.policy';
export * from './consts/mileage.policy';
export * from './consts/minimum-rental.policy';
export * from './consts/rental-duration.policy';
export * from './consts/working-periods.policy';
export * from './interfaces/deposit-policy-apply-input.interface';
export * from './interfaces/deposit-policy-config.interface';
export * from './interfaces/driver-eligibility-policy-config.interface';
export * from './interfaces/fuel-policy-config.interface';
export * from './interfaces/late-return-policy-config.interface';
export * from './interfaces/mileage-policy-config.interface';
export * from './interfaces/minimum-rental-policy-config.interface';
export * from './interfaces/policy-apply-and-evaluate.interface';
export * from './interfaces/policy-apply.interface';
export * from './interfaces/policy-evaluate.interface';
export * from './interfaces/rental-duration-policy-config.interface';
export * from './interfaces/working-periods-date-range-item.interface';
export * from './interfaces/working-periods-operating-hours-item.interface';
export * from './interfaces/working-periods-policy-config.interface';

export * from './dtos/create-policy.dto';
export * from './dtos/policy-assign.dto';
export * from './dtos/policies-stats.dto';
export * from './dtos/policy-list.dto';
export * from './dtos/policy-record.dto';
export * from './dtos/update-policy.dto';

export * from './enums/deposit-policy-type.enum';
export * from './enums/fuel-policy-type.enum';
export * from './enums/late-fee-type.enum';
export * from './enums/policy-status.enum';
export * from './enums/policy-type.enum';

export * from './functions/policy-status-to-color.function';
export * from './functions/resolve-billable-duration-value.function';
export * from './functions/resolve-rental-duration-policy-config.function';

export * from './types/policies-filters';
export * from './types/policy-config.types';

export * from './validators/policy-types-by-subject.const';
export * from './validators/schemas/create-policy.schema';
export * from './validators/schemas/policies-assign.schema';
export * from './validators/schemas/update-policy.schema';
export * from './validators/schemas/update-policy-status.schema';

export const policyValidators = {
  canCreateOrUpdate,
};
